// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2gg-X","error":"Textarea_error__2rt76","readonly":"Textarea_readonly__2EMuA","disabled":"Textarea_disabled__2F28G"};